export default "__VITE_ASSET__k7LJGhM9__"